import React from 'react';
import { createMongoAbility } from '@casl/ability';

import { useDashboardMetaBoot } from './DashboardBoot';
import { AbilityContext } from './AbilityContext';

// AbilityContext/Can déplacés dans un fichier feuille pour rompre les cycles de
// barils ; réexportés ici pour préserver les importeurs existants.
export { AbilityContext, Can } from './AbilityContext';

/**
 * Dashboard ability provider.
 */
export function DashboardAbilityProvider({ children }: any) {
  const {
    meta: { abilities },
  } = useDashboardMetaBoot();

  // Ability instance.
  const ability = createMongoAbility(abilities);

  return (
    <AbilityContext.Provider value={ability}>
      {children}
    </AbilityContext.Provider>
  );
}
